<div class="modal-dialog modal-md mt-0 mb-0" role="document">
    <div class="modal-content">
        <div class="modal-body">
            <button type="button" aria-label="Close" (click)="bsModalRef.hide()" class="btn-close btn-danger float-end"
                data-bs-dismiss="modal" aria-label="Close">
            </button>

            <div class="col-lg-12 col-md-12 col-sm-12 mb-4">
                <h4 class="titulo_seccao">Empresa/Perfil</h4>
            </div>

            <form [formGroup]="resourceForm" class="formDev">
                <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <app-select-field label="Tipo" formControlName="tipo_empresa" [itens]="ListTipoEmpresa"
                            (change)="onSelectTipoEmpresa()">
                        </app-select-field>
                    </div>
                    <div class="col-12">
                        <app-select-field-search formControlName="empresa_selecionada" label="Empresa" [itens]="ListEmpresa">
                        </app-select-field-search>
                    </div>
                </div>
            </div>
            </form>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary" (click)="onSubmit()">Confirmar</button>
            <button id="closeModal" type="button" class="btn btn-danger" data-bs-dismiss="modal"
                (click)="bsModalRef.hide()">Cancelar</button>
        </div>
    </div>
</div>